import { useLocation, useRouteError, isRouteErrorResponse } from 'react-router-dom';
import AppStatePage from './AppStatePage';
import NotFoundPage from './NotFoundPage';
import { getAppSectionHome } from '../../utils/appSectionHome';
import { isChunkLoadError, reloadOnceForChunkError } from '../../utils/lazyWithRetry';

function refreshPage() {
  window.location.reload();
}

export default function RouteErrorFallback() {
  const error = useRouteError();
  const { pathname } = useLocation();
  const home = getAppSectionHome(pathname);

  const goHome = () => {
    window.location.assign(home.path);
  };

  if (isChunkLoadError(error) && reloadOnceForChunkError()) {
    return null;
  }

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return <NotFoundPage />;
    }

    return (
      <AppStatePage
        statusCode={`${error.status} — ${error.statusText || 'Error'}`}
        statusColor="var(--rb-color-accent-negative, #DB0A40)"
        title="Something went wrong"
        message={
          typeof error.data === 'string' && error.data
            ? error.data
            : `Peak could not load this page. Try again or ${home.returnPhrase}.`
        }
        actions={[
          { label: 'Try Again', onClick: refreshPage },
          { label: home.label, variant: 'secondary', onClick: goHome },
        ]}
      />
    );
  }

  const message =
    error instanceof Error
      ? error.message
      : 'An unexpected error occurred while loading this page.';

  const chunkError = isChunkLoadError(error);

  return (
    <AppStatePage
      statusCode={chunkError ? undefined : 'Unexpected Error'}
      statusColor="var(--rb-color-accent-negative, #DB0A40)"
      title={chunkError ? 'A new version is available' : 'Something went wrong'}
      message={
        chunkError
          ? 'Peak was updated while you had this tab open. Refresh to load the latest version.'
          : message
      }
      actions={[
        { label: chunkError ? 'Refresh' : 'Try Again', onClick: refreshPage },
        { label: home.label, variant: 'secondary', onClick: goHome },
      ]}
    />
  );
}
